<template>
  <button
    :type="type"
    :class="btnClass"
    @click="handleClick">
    <span v-if="!link">{{ name }}</span>
    <a
      v-if="link"
      :href="link"
      target="_blank"
      rel="noopener noreferrer">
      {{ name }}
    </a>
    </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    name: {
      type: String,
      required: true,
      default: () => ''
    },
    color: {
      type: String,
      required: true,
      default: () => ''
    },
    transparent: {
      type: Boolean,
      required: false,
      default: () => false
    },
    type: {
      type: String,
      required: false,
      default: () => 'button'
    },
    link: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  },
  computed: {
    btnClass () {
      return {
        blue: this.color === 'blue',
        orange: this.color === 'orange',
        grey: this.color === 'grey',
        white: this.color === 'white',
        transparent: this.transparent
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

button {
  border: 2px solid;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  height: min-content;
  transition: all 0.2s ease-in-out;
  border-radius: 2px;

  a {
    color: inherit;
    text-decoration: none;
  }

  span, a {
    padding: calc(#{$base-padding / 1.5}) calc(#{$base-padding * 2});
    display: inline-block;
  }

  &.blue {
    background-color: $blue;
    border-color: $blue;
    color: white;

    &:hover {
      background-color: transparent;
      color:$blue;
    }

    &.transparent {
      background-color: transparent;
      color: $blue;

      &:hover {
        background-color: $blue;
        color: #FFFFFF;
      }
    }
  }

  &.orange {
    background-color: $orange;
    border-color: $orange;
    color: white;

    &:hover {
      background-color: transparent;
      color:$orange;
    }

    &.transparent {
      background-color: transparent;
      color: $orange;

      &:hover {
        background-color: $orange;
        color: #FFFFFF;
      }
    }
  }

  &.grey {
    background-color: $grey;
    border-color: $grey;
    color: white;

    &:hover {
      background-color: transparent;
      color:$grey;
    }

    &.transparent {
      background-color: transparent;
      color: $grey;

      &:hover {
        background-color: $grey;
        color: #FFFFFF;
      }
    }
  }

  &.white {
    background-color:  #FFFFFF;
    border-color: #FFFFFF;
    color: $grey;

    &:hover {
      background-color: transparent;
      color: #FFFFFF;
    }

    &.transparent {
      background-color: transparent;
      color:  #FFFFFF;

      &:hover {
        background-color:  #FFFFFF;
        color: $grey;
      }
    }
  }
}
</style>
